export default __webpack_public_path__ + "static/media/ic_scene.10f754a5b55dfa7ff7bfcc5d93ceb37f.svg";